
export const changeFavicon = (brand) => {
  let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = window.location.origin + '/static/logo/' + brand + '.ico'
  document.getElementsByTagName('head')[0].appendChild(link)
}

export const changeTitle = (title) => {
  document.title = title
}

